import * as userApi from "./user";
import * as adminApi from "./admin";

export const API = {
  user: userApi,
  admin: adminApi
};
